import { ForegroundReflection } from './foreground-reflection'

export interface NotificationReflectionInterface {
  notificationId?: number
  rid?: number
  /**
   * 是否已读
   */
  isReaded?: boolean
  /**
   * 通知人
   */
  reflection?: ForegroundReflection
  /**
   * 模板变量
   */
  variables?: string
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number
}

export class NotificationReflection implements NotificationReflectionInterface {
  notificationId?: number
  rid?: number
  /**
   * 是否已读
   */
  isReaded?: boolean
  /**
   * 通知人
   */
  reflection?: ForegroundReflection
  /**
   * 模板变量
   */
  variables?: string
  /**
   * 主键 ID
   */
  id: number
  /**
   * 学校 ID
   */
  schoolId: number

  constructor(props: NotificationReflectionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      notificationId: _notificationId,
      rid: _rid,
      isReaded: _isReaded,
      reflection: _reflection,
      variables: _variables,
      id: _id,
      schoolId: _schoolId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.notificationId = _notificationId
    this.rid = _rid
    this.isReaded = _isReaded
    this.reflection = _reflection
      ? new ForegroundReflection(_reflection)
      : _reflection
    this.variables = _variables
    this.id = _id
    this.schoolId = _schoolId
  }
}
